import { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation, useHistory } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import ViewPDF from "../../Components/ViewPDF";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function CheckISEE(props) {
  const apiToken = useContext(TokenContext);

  const [value, setValue] = useState();
  const [file, setFile] = useState();
  const [userData, setUserData] = useState();
  const [validation, setValidation] = useState(false);
  const [validationISEE, setValidationISEE] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenRefuse, toggleModalRefuse] = useState(false);
  const [data, setData] = useState({});
  const [id, setId] = useState(null);
  const [iseeData, setIseeData] = useState(null);
  const isError = iseeData?.state === "ERROR";

  const query = useQuery();
  const [selected, setSelected] = useState("ordinario");

  const handleChange = (event) => {
    setSelected(event.target.value);
  };

  const selectedValue =
    selected === "ordinario"
      ? iseeData?.ordinario
      : selected === "ristretto"
        ? iseeData?.ristretto
        : selected === "dichiarato"
          ? iseeData?.dichiarato
          : null;

  const loadIsee = async (iseeId) => {
    const response = await Repo.getIsee(apiToken, iseeId);
    if (response.status === 200) {
      console.log("response", response.data);
      //  setFile("data:application/pdf;base64," + response.data.file);
      var obj = document.createElement("object");
      obj.type = "application/pdf";
      obj.data = "data:application/pdf;base64,";
      obj.length = 0;
      setFile(obj);
      obj.data = "data:application/pdf;base64," + response.data.file;
      obj.length = response.data.file.length;
      setFile(obj);
      setUserData(response.data.user);
      setValue(response.data.value);
      setIseeData(response.data);
      console.log("Isee data:", response.data);
    }
  };

  // Recupero idIsee dal query param
  useEffect(() => {
    const idFromQuery = query.get("idIsee");
    if (idFromQuery) {
      setId(idFromQuery);
    }
  }, [query]);

  // Caricamento dati ISEE al cambio di id
  useEffect(() => {
    const loadData = async () => {
      if (!id) return;

      setLoading(true);

      try {
        await loadIsee(id);
      } catch (err) {
        console.error("Errore durante il caricamento ISEE:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [id]);

  const confirmIsee = () => {
    setValidation(true);
    const tempData = {
      id: id,
      state: 1,
      value: selectedValue,
    };
    setData(tempData);
    if (!props.apiToken) {
      toggleModal(true);
    }
  };

  const refuseIsee = () => {
    setValidation(true);
    const tempData = {
      id: id,
      state: 2,
    };
    setData(tempData);
    if (!props.apiToken) {
      toggleModalRefuse(true);
    }
  };

  const sendISEEApi = async () => {
    const payload = {
      ...data,
      id: id,
      value: selectedValue,
      protocollo: iseeData?.protocollo,
      date: iseeData?.date,
      scadenza: iseeData?.scadenza,
      ordinario: iseeData?.ordinario,
      ristretto: iseeData?.ristretto,
    };

    try {
      const response = await Repo.postConfirmIsee(apiToken, payload);

      if (response.status === 200) {
        const redirectTo =
          process.env.PUBLIC_URL +
          `/lista_utenti/dati_utente?citizen=${iseeData.user.id}`;

        window.location.href = redirectTo;
      }
    } catch (error) {
      console.error("Errore nell'invio dell'ISEE:", error);
    }
  };

  const history = useHistory();
  return (
    <>
      <div>
        <h1>Verifica ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            Verifica gli ISEE caricati dagli utenti confronta il valore inserito
            con quello estratto dal documento PDF
          </p>
        </div>

        <div className="row mb-2">
          <div className="col-12"></div>
        </div>
        <div className="row">
          <ViewPDF data={file && file.data} length={file && file.length} />

          <div className="col-lg-4 pl-5">
            <h3>Riepilogo utente</h3>

            <div>
              Nome cognome:
              <div className="clear"></div>
              <strong>
                {userData && userData.firstName + " " + userData.lastName}
              </strong>
              <div className="clear"></div>
              Codice Fiscale: <div className="clear"></div>
              <strong>
                <Link
                  to={`/lista_utenti/dati_utente?citizen=${iseeData?.user?.id}`}
                >
                 {userData?.fiscalCode}
                </Link> 


              </strong>
              <div className="clear"></div>
              Email:
              <div className="clear"></div>
              <strong>{userData && userData.email}</strong>
            </div>

            <hr />

            <div className="clear"></div>
            {isError && (
              <div className="alert alert-warning">
                {iseeData?.detail ?? "Errore Isee"}
              </div>
            )}
            <p className="mt-2">Protocollo ISEE estratto in automatico:</p>
            <div className="row mb-4">
              <Input
                id="valueProtocollo"
                type="text"
                disabled={!isError}
                value={iseeData?.protocollo ?? ""}
                onChange={(e) =>
                  setIseeData({
                    ...iseeData,
                    protocollo: e.target.value,
                  })
                }
              />
            </div>

            <div className="clear"></div>
            <p className="mt-2">Data rilascio ISEE</p>
            <div className="row mb-4">
              <Input
                id="date"
                type="date"
                disabled={!isError}
                value={iseeData?.date?.substring?.(0, 10) ?? ""}
                onChange={(e) =>
                  setIseeData({
                    ...iseeData,
                    date: e.target.value,
                  })
                }
              />
            </div>

            <div className="clear"></div>
            <p className="mt-2">Scadenza ISEE</p>
            <div className="row mb-4">
              <Input
                id="scadenza"
                type="date"
                disabled={!isError}
                value={iseeData?.scadenza?.substring?.(0, 10) ?? ""}
                onChange={(e) =>
                  setIseeData({
                    ...iseeData,
                    scadenza: e.target.value,
                  })
                }
              />
            </div>

            <div>
              <label>
                <input
                  type="radio"
                  value="ordinario"
                  checked={selected === "ordinario"}
                  onChange={handleChange}
                />
                &nbsp;ISEE Ordinario (
                {iseeData?.ordinario ? iseeData?.ordinario : "0"})
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  value="ristretto"
                  checked={selected === "ristretto"}
                  onChange={handleChange}
                />
                &nbsp;ISEE Ristretto (
                {iseeData?.ristretto ? iseeData?.ristretto : "N/A"})
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  value="dichiarato"
                  checked={selected === "dichiarato"}
                  onChange={handleChange}
                />
                &nbsp;ISEE Dichiarato (
                {iseeData?.value ? iseeData?.value : "N/A"})
              </label>

              <div style={{ marginTop: "1rem" }}>
                <strong>ISEE Selezionato:</strong> {selectedValue ?? "N/A"}
              </div>
            </div>

            <div className="clear"></div>

            <div className="row mb-4"></div>
            <div className="d-flex justify-content-around">
              <div>
                <button
                  type="button "
                  className="btn btn-success"
                  data-toggle="tooltip"
                  data-placement="top"
                  onClick={() => confirmIsee()}
                  title="Conferma"
                >
                  Conferma
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-warning"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Rifiuta"
                  onClick={() => refuseIsee()}
                >
                  Rifiuta
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Indietro"
                  onClick={() => history.goBack()}
                >
                  Indietro
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalRefuse}
        isOpen={isOpenRefuse}
        header="Rifiuto ISEE"
        body="Confermi di voler rifiutare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>

      {loading && <Loader></Loader>}
    </>
  );
}

export default CheckISEE;
